(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ampm-policy"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ampm-cookie-settings]');
    if (!button) return;
    const errorMessage = button.parentElement.querySelector('[data-ampm-cookie-error]');
    button.disabled = true;
    errorMessage.hidden = true;
    try {
      if (!window.privacyBanner?.showPreferences) {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }
      await window.privacyBanner.showPreferences();
    } catch {
      errorMessage.hidden = false;
    } finally {
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ampm-product-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ampm-bundle-gallery')) {
    customElements.define('ampm-bundle-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.viewport = this.querySelector('[data-gallery-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.buttons = Array.from(this.querySelectorAll('[data-gallery-index]'));
        if (!this.viewport || !this.slides.length) return;
        const signal = this.controller.signal;
        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.select(index), { signal });
        });
        this.viewport.addEventListener('scroll', () => this.updateCurrent(), { passive: true, signal });
        this.viewport.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let index = this.currentIndex();
          if (event.key === 'ArrowLeft') index -= 1;
          if (event.key === 'ArrowRight') index += 1;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this.slides.length - 1;
          this.select(index);
        }, { signal });
        this.updateCurrent();
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      currentIndex() {
        return Math.round(this.viewport.scrollLeft / this.viewport.clientWidth) || 0;
      }
      select(index) {
        const next = Math.max(0, Math.min(index, this.slides.length - 1));
        this.viewport.scrollTo({ left: next * this.viewport.clientWidth, behavior: 'auto' });
      }
      updateCurrent() {
        const current = this.currentIndex();
        this.classList.toggle('ampm-bundle__visual--photo', current < 2);
        this.buttons.forEach((button, index) => button.setAttribute('aria-current', String(index === current)));
      }
    });
  }

  if (!customElements.get('ampm-bundle-picker')) {
    customElements.define('ampm-bundle-picker', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.productSection = this.closest('.ampm-product-bundle');
        this.options = Array.from(this.querySelectorAll('input[type="radio"]'));
        this.reviewButton = this.querySelector('[data-bundle-review]');
        this.dialog = this.querySelector('dialog');
        if (!this.productSection || !this.options.length || !this.reviewButton || !this.dialog) return;
        this.options.forEach((option) => option.addEventListener('change', () => this.update(true), { signal }));
        this.reviewButton.addEventListener('click', () => this.dialog.showModal(), { signal });
        this.querySelector('[data-bundle-close]').addEventListener('click', () => this.dialog.close(), { signal });
        this.dialog.addEventListener('click', (event) => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, { signal });
        this.dialog.addEventListener('close', () => this.reviewButton.focus({ preventScroll: true }), { signal });
        this.reviewButton.disabled = false;
        this.update(false);
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
      }
      update(announce) {
        const selected = this.options.find((option) => option.checked);
        if (!selected) return;
        const isBundle = selected.value === '3';
        this.productSection.querySelector('[data-bundle-price]').textContent = selected.dataset.price;
        this.productSection.querySelector('[data-bundle-size]').textContent = selected.dataset.size;
        this.reviewButton.textContent = selected.dataset.cta;
        this.querySelector('[data-bundle-savings]').hidden = !isBundle;
        this.querySelector('[data-bundle-dialog-saving]').hidden = !isBundle;
        this.querySelector('[data-bundle-dialog-title]').textContent = selected.dataset.title;
        this.querySelector('[data-bundle-dialog-price]').textContent = selected.dataset.price;
        if (announce) this.querySelector('[data-bundle-announcement]').textContent = selected.dataset.announcement;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ampm-product-supply"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ampm-product-gallery')) {
    customElements.define('ampm-product-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.viewport = this.querySelector('[data-gallery-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.buttons = Array.from(this.querySelectorAll('[data-gallery-index]'));
        if (!this.viewport || !this.slides.length) return;
        const signal = this.controller.signal;
        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.select(index), { signal });
        });
        this.viewport.addEventListener('scroll', () => this.updateCurrent(), { passive: true, signal });
        this.viewport.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let index = this.currentIndex();
          if (event.key === 'ArrowLeft') index -= 1;
          if (event.key === 'ArrowRight') index += 1;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this.slides.length - 1;
          this.select(index);
        }, { signal });
        this.updateCurrent();
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      currentIndex() {
        return Math.round(this.viewport.scrollLeft / this.viewport.clientWidth) || 0;
      }
      select(index) {
        const next = Math.max(0, Math.min(index, this.slides.length - 1));
        this.viewport.scrollTo({ left: next * this.viewport.clientWidth, behavior: 'auto' });
      }
      updateCurrent() {
        const current = this.currentIndex();
        this.classList.toggle('ampm-product__visual--photo', current < 2);
        this.buttons.forEach((button, index) => button.setAttribute('aria-current', String(index === current)));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ampm-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ampm-product-gallery')) {
    customElements.define('ampm-product-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.viewport = this.querySelector('[data-gallery-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.buttons = Array.from(this.querySelectorAll('[data-gallery-index]'));
        if (!this.viewport || !this.slides.length) return;
        const signal = this.controller.signal;
        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.select(index), { signal });
        });
        this.viewport.addEventListener('scroll', () => this.updateCurrent(), { passive: true, signal });
        this.viewport.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let index = this.currentIndex();
          if (event.key === 'ArrowLeft') index -= 1;
          if (event.key === 'ArrowRight') index += 1;
          if (event.key === 'Home') index = 0;
          if (event.key === 'End') index = this.slides.length - 1;
          this.select(index);
        }, { signal });
        this.updateCurrent();
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      currentIndex() {
        return Math.round(this.viewport.scrollLeft / this.viewport.clientWidth) || 0;
      }
      select(index) {
        const next = Math.max(0, Math.min(index, this.slides.length - 1));
        this.viewport.scrollTo({ left: next * this.viewport.clientWidth, behavior: 'auto' });
      }
      updateCurrent() {
        const current = this.currentIndex();
        this.classList.toggle('ampm-product__visual--photo', current < 2);
        this.buttons.forEach((button, index) => button.setAttribute('aria-current', String(index === current)));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);
  // lova: bij herladen midden op de pagina meteen crème (Dawn zet de klasse pas bij de eerste scroll)
  if (window.scrollY > 0) document.querySelector('.section-header')?.classList.add('scrolled-past-header');

  } catch(e) { console.error(e); }
})();
})();
